import {apiRequest} from "../../../utils/AxiosHelper";
import {PAGINATION} from "../../../constants/constants";
import APIs from "../../../modules/settings/APIs";
import {useAppSelector} from "../../../hooks/hooks";
import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {OptionItem} from "../../../types";

interface OptionsParams {
  propertyFind?: string;
  valueFind?: string;
  propertyOrder?: string;
  isFilterable?: boolean;
  optionKey?: string;
  start?: number;
  limit?: number;
}

const fetchOptions = async (params: OptionsParams): Promise<OptionItem[]> => {
  const response = await apiRequest.get(APIs.parameters.common.option.list, {
    params: {
      start: params.start || 0,
      limit: params.limit || PAGINATION.DEFAULT_PAGE_LIMIT,
      propertyFind: params.propertyFind || 'f.identified',
      valueFind: params.valueFind ||'ISSUE',
      propertyOrder: params.propertyOrder || 'f.idFore',
      isFilterable: params.isFilterable,
    }
  });

  return response.data.data[params.optionKey || 'options'] || [];
};

export const useOptions = (params: OptionsParams = {}, queryOptions?: Partial<UseQueryOptions<OptionItem[], Error>>) => {
  const {isAuthenticated, token} = useAppSelector((state) => state.session);

  return useQuery({
    queryKey: ['options', params],
    queryFn: () => fetchOptions(params),
    staleTime: 5 * 60 * 1000,
    retry: 2,
    enabled: isAuthenticated && !!token, // Default enabled condition
    ...queryOptions, // Spread additional query options (including enabled override)
  });
};
